import { render, staticRenderFns } from "./ChatLayout_test.vue?vue&type=template&id=357fd6ea&scoped=true&lang=html&"
import script from "./ChatLayout_test.vue?vue&type=script&lang=js&"
export * from "./ChatLayout_test.vue?vue&type=script&lang=js&"
import style0 from "./ChatLayout_test.vue?vue&type=style&index=0&id=357fd6ea&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "357fd6ea",
  null
  
)

export default component.exports